import { ComponentWithAs, Icon, IconProps } from '@chakra-ui/react'

const IconComp: ComponentWithAs<'svg', IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon fill="none" {...props}>
      <circle
        cx="11.9987"
        cy="9.89816"
        r="4.39816"
        stroke="#FFFFFF"
        strokeWidth="2"
      ></circle>
      <path
        d="M4.46204 19.194C4.29302 19.7197 4.58224 20.283 5.10803 20.452C5.63381 20.621 6.19706 20.3318 6.36608 19.806L4.46204 19.194ZM17.6202 19.7633C17.7656 20.2961 18.3154 20.6101 18.8482 20.4647C19.381 20.3192 19.695 19.7694 19.5496 19.2366L17.6202 19.7633ZM6.36608 19.806C7.28224 16.9561 9.70586 15.4681 12.0951 15.424C14.456 15.3805 16.796 16.7441 17.6202 19.7633L19.5496 19.2366C18.4701 15.2823 15.2794 13.365 12.0582 13.4243C8.86527 13.4832 5.65529 15.482 4.46204 19.194L6.36608 19.806Z"
        fill="#FFFFFF"
      ></path>
    </Icon>
  )
}
IconComp.defaultProps = {
  viewBox: '0 0 24 24',
  boxSize: '24px',
}

export default IconComp
